import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex items-center -mt-12" }
const _hoisted_4 = { class: "relative w-full bg-light bg-opacity-50 py-2 mb-6 mt-4 px-2" }
const _hoisted_5 = { class: "select-none uppercase text-muted text-xs mt-2 mr-2 absolute top-0 right-0" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 xl:gap-8 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-5"
}
const _hoisted_9 = { class: "absolute w-full transform -translate-x-1/2 left-1/2" }
const _hoisted_10 = { class: "text-center opacity-70" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col h-full" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mx-auto my-auto text-7xl opacity-70 material-icons-outlined" }, " add ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full transform -translate-x-1/2 left-1/2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-center opacity-70 w-11/12" }, " Esercizi con scrittura a mano ")
], -1)
const _hoisted_13 = { class: "flex flex-col h-full relative" }
const _hoisted_14 = {
  style: {"width":"100px","height":"100px","margin":"auto","opacity":"0.45"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("title", null, "draw", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", { d: "M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "chip chip-primary absolute flex items-center align-center -bottom-2 -right-4 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "BETA")
], -1)
const _hoisted_19 = {
  key: 1,
  class: "mt-4 w-full grid grid-cols-1 gap-4 xl:gap-8 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-5"
}
const _hoisted_20 = { class: "mb-4 text-muted" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Esercizi con scrittura a mano libera"),
  /*#__PURE__*/_createElementVNode("div", { class: "chip chip-primary flex items-center align-center text-uppercase -mb-0 -mt-0.5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "BETA")
  ])
], -1)
const _hoisted_22 = { class: "flex items-center justify-start space-x-8 w-full mt-6 mb-10" }
const _hoisted_23 = { class: "w-max bg-primary bg-opacity-10 rounded-2xl p-4 text-primary shadow" }
const _hoisted_24 = {
  style: {"width":"80px","fill":"currentColor"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("title", null, "draw", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", { d: "M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z" }, null, -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "" }, "Risolvi gli esercizi scrivendo a mano libera la risposta."),
  /*#__PURE__*/_createElementVNode("p", null, " L'AI correggerà automaticamente la tua risposta, dandoti feedback e suggerimenti. "),
  /*#__PURE__*/_createElementVNode("p", null, " Avrai bisogno di un dispositivo con schermo touch e una pencil, ma puoi anche caricare un'immagine. ")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, "Scegli un argomento", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "mt-8 text-muted text-sm" }, " Le correzioni e i feedback forniti dall'AI potrebbero contenere errori. Verificare sempre le soluzioni ufficiali fornite dai docenti. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EventParticipationPreview = _resolveComponent("EventParticipationPreview")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!
  const _component_PracticeTemplateEditorNew = _resolveComponent("PracticeTemplateEditorNew")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_v_tour = _resolveComponent("v-tour")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Btn, {
          class: _normalizeClass([{
						'opacity-0': _ctx.firstLoading || _ctx.mainStore.practiceParticipations.length <= 3,
					}, "ml-auto"]),
          variant: 'icon',
          outline: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBookmarkedOnly = !_ctx.showBookmarkedOnly)),
          tooltip: 
						_ctx.showBookmarkedOnly
							? _ctx.$t('student_course_dashboard.show_all_practices')
							: _ctx.$t('student_course_dashboard.show_bookmarked')
					
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.showBookmarkedOnly ? 'material-icons' : 'material-icons-outlined'])
            }, "bookmarks", 2)
          ]),
          _: 1
        }, 8, ["class", "tooltip"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("misc.ads")), 1),
        _withDirectives(_createElementVNode("div", {
          class: "hidden lg:block",
          innerHTML: _ctx.ads3Code
        }, null, 8, _hoisted_6), [
          [_vShow, _ctx.ads3Code]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "lg:hidden",
          innerHTML: _ctx.adsMobileCode
        }, null, 8, _hoisted_7), [
          [_vShow, _ctx.adsMobileCode]
        ])
      ], 512), [
        [_vShow, _ctx.ads3Code || _ctx.adsMobileCode]
      ]),
      (!_ctx.firstLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createBlock(_component_Card, {
              id: "create-practice-btn",
              "margin-less": true,
              hoverable: false,
              filled: true,
              "border-less": true,
              class: "relative overflow-hidden text-gray-600 cursor-pointer md:h-23rem h-64 elevate-when-pressed bg-light hover:bg-gray-200 transition-all duration-300 ease-in-out",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCreatePractice()))
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("student_course_dashboard.new_practice")), 1)
                ])
              ]),
              body: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })), [
              [_directive_wave]
            ]),
            (_ctx.hasFeatures(['draw_practice']))
              ? _withDirectives((_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  id: "create-draw-practice-btn",
                  "margin-less": true,
                  hoverable: false,
                  filled: true,
                  "border-less": true,
                  class: "relative overflow-hidden text-gray-600 cursor-pointer md:h-23rem h-64 elevate-when-pressed bg-light hover:bg-gray-200 transition-all duration-300 ease-in-out",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCreateDrawPractice()))
                }, {
                  header: _withCtx(() => [
                    _hoisted_12
                  ]),
                  body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_17)),
                      _hoisted_18
                    ])
                  ]),
                  _: 1
                })), [
                  [_directive_wave]
                ])
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPracticeParticipations, (participation) => {
              return (_openBlock(), _createBlock(_component_EventParticipationPreview, {
                key: 'practice-participation-' + participation.id,
                participation: participation,
                onBookmark: ($event: any) => (_ctx.onBookmark(participation)),
                loading: _ctx.loadingParticipations.has(participation.id)
              }, null, 8, ["participation", "onBookmark", "loading"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_SkeletonCard, { full: true }),
            _createVNode(_component_SkeletonCard, { full: true }),
            _createVNode(_component_SkeletonCard, { full: true }),
            _createVNode(_component_SkeletonCard, { full: true })
          ])),
      (!_ctx.firstLoading)
        ? (_openBlock(), _createBlock(_component_VueEternalLoading, {
            key: 2,
            load: _ctx.onLoadMore,
            class: "mt-8",
            "is-initial": _ctx.isInitialInfiniteLoad,
            "onUpdate:is-initial": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
          }, {
            loading: _withCtx(() => [
              _createVNode(_component_Spinner)
            ]),
            "no-more": _withCtx(() => [
              _createTextVNode("   ")
            ]),
            _: 1
          }, 8, ["load", "is-initial"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      onNo: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCancelPracticeEditorDialog())),
      onYes: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onBeginPractice())),
      noText: _ctx.$t('dialog.default_cancel_text'),
      yesText: 
				_ctx.practiceEditorDialogLoading
					? _ctx.$t('misc.wait')
					: _ctx.$t('practice_template_editor.begin_practice')
			,
      fullWidth: _ctx.mainStore.tags.length > 0,
      disableOk: 
				_ctx.practiceEditorDialogLoading ||
				_ctx.draftEventTemplate.rules.length === 0 ||
				_ctx.isEditingRule
			,
      showDialog: _ctx.showPracticeEditorDialog,
      loading: _ctx.practiceEditorDialogLoading
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("student_course_dashboard.new_practice")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.mainStore.tags.length > 0
							? _ctx.$t("practice_template_editor.choose_tags_text")
							: _ctx.$t("practice_template_editor.choose_exercises_no_tag_text")), 1),
        _createVNode(_component_PracticeTemplateEditorNew, {
          modelValue: _ctx.draftEventTemplate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.draftEventTemplate) = $event)),
          onIsEditing: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isEditingRule = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["noText", "yesText", "fullWidth", "disableOk", "showDialog", "loading"]),
    _createVNode(_component_Dialog, {
      onNo: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCancelPracticeEditorDialog())),
      onYes: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onBeginPractice())),
      noText: _ctx.$t('dialog.default_cancel_text'),
      yesText: 
				_ctx.practiceEditorDialogLoading
					? _ctx.$t('misc.wait')
					: _ctx.$t('practice_template_editor.begin_practice')
			,
      fullWidth: _ctx.mainStore.tags.length > 0,
      disableOk: 
				_ctx.practiceEditorDialogLoading ||
				_ctx.draftEventTemplate.rules.length === 0 ||
				_ctx.isEditingRule
			,
      showDialog: _ctx.showDrawPracticeEditorDialog,
      loading: _ctx.practiceEditorDialogLoading
    }, {
      title: _withCtx(() => [
        _hoisted_21
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_27))
          ]),
          _hoisted_28
        ]),
        _hoisted_29,
        _createVNode(_component_PracticeTemplateEditorNew, {
          modelValue: _ctx.draftEventTemplate,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.draftEventTemplate) = $event)),
          onIsEditing: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isEditingRule = $event)),
          onlyDrawExercises: true,
          singleTag: true
        }, null, 8, ["modelValue"]),
        _hoisted_30
      ]),
      _: 1
    }, 8, ["noText", "yesText", "fullWidth", "disableOk", "showDialog", "loading"]),
    _createVNode(_component_v_tour, {
      name: "demoStudentTour",
      steps: _ctx.demoStudentTourSteps,
      options: _ctx.tourOptions
    }, null, 8, ["steps", "options"])
  ]))
}